<template>
  <div>
    <div class="level is-mobile">
      <div class="level-left">
        <div class="title is-5">
          {{ $t('inspiration_list.labels.inspirations') }}
        </div>
      </div>
    </div>

    <div
      v-if="inspiration_list"
      class="mb-4 flex items-center"
    >
      <TitleSmall>
        {{ $truncate(inspiration_list.attributes.name, 50) }}
      </TitleSmall>
      <ButtonTertiary
        class="ml-2"
        @onClick="showInspirationLists"
      >
        {{ $t('contact.actions.backInspirationLists') }}
      </ButtonTertiary>
    </div>

    <p
      v-if="inspiration_lists.length === 0"
      class="subtitle is-6 italic"
    >
      {{ $t('inspiration_list.labels.noInspirationLists') }}
    </p>

    <div
      v-if="!inspiration_list"
      class="columns is-multiline"
    >
      <InspirationList
        v-for="inspirationList in inspiration_lists"
        :key="inspirationList.id"
        class="column is-3-desktop"
        :inspiration_list="inspirationList"
        @select="showInspirations"
      />
    </div>
    <div
      v-else
      class="columns is-multiline"
    >
      <InspirationItem
        v-for="inspiration in inspirations_list"
        :key="inspiration.id"
        class="column is-half-desktop is-one-third-tablet"
        :document="documents_by_inspiration[inspiration.id]"
        :inspiration="inspiration"
        :isCustomer="false"
      />
    </div>
  </div>
</template>

<script>
import { ATTACHABLE_TYPES } from '@/app/data/model_constants';
import { mapActions, mapGetters } from 'vuex';
import InspirationItem from '@/app/shared_components/inspirations/InspirationItem.vue';
import InspirationList from '@/app/_employees/components/inspirations/InspirationList.vue';

export default {
  name: 'CustomerInspirations',

  components: { InspirationList, InspirationItem },

  props: {
    customer: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      inspiration_list: null,
      inspiration_lists: [],
    };
  },

  computed: {
    ...mapGetters(['inspirations', 'documents']),

    inspirations_list() {
      return this.inspiration_list
        ? _.pickBy(this.inspirations, ['attributes.inspiration_list_id', this.inspiration_list.id])
        : [];
    },
    documents_by_inspiration() {
      const inspiration_ids = _.map(this.inspirations_list, 'id');
      return this.inspiration_list
        ? _.chain(this.documents)
            .filter(
              (document) =>
                document.attributes.attachable_type === ATTACHABLE_TYPES.INSPIRATION &&
                _.includes(inspiration_ids, document.attributes.attachable_id),
            )
            .keyBy('attributes.attachable_id')
            .value()
        : {};
    },
  },

  watch: {
    customer(oldVal, newVal) {
      if (oldVal !== newVal) {
        this.showInspirationLists();
      }
    },
  },

  created() {
    this.showInspirationLists();
  },

  methods: {
    ...mapActions(['FETCH_INSPIRATION_LIST', 'FETCH_INSPIRATION_LISTS']),

    async showInspirationLists() {
      this.inspiration_list = null;
      this.inspiration_lists = await this.FETCH_INSPIRATION_LISTS({ customer_id: this.customer.id });
    },

    async showInspirations(inspiration_list_id) {
      this.inspiration_list = await this.FETCH_INSPIRATION_LIST({ id: inspiration_list_id });
    },
  },
};
</script>
